


// // frontend/src/components/booking/BookingConfirmation.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';

// const BookingConfirmation = ({ booking }) => {
//   const formatTime = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false
//     });
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       weekday: 'long',
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   // Debug logging to see what data we're getting
//   console.log('📄 BookingConfirmation received booking:', booking);

//   // Handle missing booking data
//   if (!booking) {
//     return (
//       <div className="max-w-2xl mx-auto">
//         <div className="bg-white rounded-lg shadow-md p-8 text-center">
//           <div className="text-red-600 mb-4">
//             <h1 className="text-2xl font-bold">Booking data not available</h1>
//             <p>There was an issue loading your booking confirmation.</p>
//           </div>
//           <Link to="/" className="btn btn-primary">
//             Return to Home
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   // Extract data with fallbacks
//   const bookingReference = booking.booking_reference || booking.bookingReference || 'N/A';
//   const totalAmount = booking.total_amount || booking.totalAmount || 0;
//   const passengers = booking.passengers || [];
//   const flight = booking.flight || {};
//   const flightDetails = booking.flight_details || {};
  
//   // Use flight details from booking if available, otherwise use flight object
//   const flightInfo = {
//     airline_name: flight.airline_name || flightDetails.airline_name || 'Unknown Airline',
//     flight_number: flight.flight_number || flightDetails.flight_number || 'N/A',
//     origin_airport: flight.origin_airport || flightDetails.origin || 'N/A',
//     destination_airport: flight.destination_airport || flightDetails.destination || 'N/A',
//     origin_city: flight.origin_city || flight.origin_airport || 'N/A',
//     destination_city: flight.destination_city || flight.destination_airport || 'N/A',
//     departure_time: flight.departure_time || flightDetails.departure_time,
//     arrival_time: flight.arrival_time || flightDetails.arrival_time
//   };

//   return (
//     <div className="max-w-2xl mx-auto">
//       <div className="bg-white rounded-lg shadow-md p-8 text-center">
//         {/* Success Icon */}
//         <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-6">
//           <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//           </svg>
//         </div>

//         <h1 className="text-3xl font-bold text-green-600 mb-2">
//           Booking Confirmed!
//         </h1>
//         <p className="text-gray-600 mb-8">
//           Your flight has been successfully booked. You will receive a confirmation email shortly.
//         </p>

//         {/* Booking Reference */}
//         <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-8">
//           <div className="text-sm text-blue-800 mb-1">Booking Reference</div>
//           <div className="text-2xl font-bold text-blue-600">{bookingReference}</div>
//         </div>

//         {/* Flight Details */}
//         <div className="border-t border-gray-200 pt-8">
//           <h2 className="text-xl font-semibold mb-6">Flight Details</h2>
          
//           <div className="space-y-4 text-left">
//             <div className="flex justify-between">
//               <span className="text-gray-600">Flight:</span>
//               <span className="font-medium">{flightInfo.airline_name} {flightInfo.flight_number}</span>
//             </div>
            
//             <div className="flex justify-between">
//               <span className="text-gray-600">Route:</span>
//               <span>{flightInfo.origin_city} ({flightInfo.origin_airport}) → {flightInfo.destination_city} ({flightInfo.destination_airport})</span>
//             </div>
            
//             {flightInfo.departure_time && (
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Date:</span>
//                 <span>{formatDate(flightInfo.departure_time)}</span>
//               </div>
//             )}
            
//             {flightInfo.departure_time && (
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Departure:</span>
//                 <span>{formatTime(flightInfo.departure_time)}</span>
//               </div>
//             )}
            
//             {flightInfo.arrival_time && (
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Arrival:</span>
//                 <span>{formatTime(flightInfo.arrival_time)}</span>
//               </div>
//             )}
            
//             <div className="flex justify-between">
//               <span className="text-gray-600">Passengers:</span>
//               <span>{passengers.length}</span>
//             </div>
//           </div>
//         </div>

//         {/* Passenger Details */}
//         {passengers.length > 0 && (
//           <div className="border-t border-gray-200 pt-8">
//             <h2 className="text-xl font-semibold mb-6">Passengers</h2>
            
//             <div className="space-y-3">
//               {passengers.map((passenger, index) => (
//                 <div key={index} className="flex justify-between items-center bg-gray-50 p-3 rounded">
//                   <span className="font-medium">
//                     {passenger.first_name} {passenger.last_name}
//                   </span>
//                   <span className="text-gray-600">
//                     {passenger.gender} • Born {passenger.date_of_birth ? new Date(passenger.date_of_birth).toLocaleDateString() : 'N/A'}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Payment Summary */}
//         <div className="border-t border-gray-200 pt-8">
//           <h2 className="text-xl font-semibold mb-6">Payment Summary</h2>
          
//           <div className="space-y-3 text-left">
//             <div className="flex justify-between">
//               <span className="text-gray-600">Subtotal:</span>
//               <span>${totalAmount ? totalAmount.toFixed(2) : '0.00'}</span>
//             </div>
//             <div className="flex justify-between">
//               <span className="text-gray-600">Taxes & Fees:</span>
//               <span>$0.00</span>
//             </div>
//             <div className="border-t border-gray-200 pt-3 flex justify-between text-lg font-semibold">
//               <span>Total Paid:</span>
//               <span className="text-green-600">${totalAmount ? totalAmount.toFixed(2) : '0.00'}</span>
//             </div>
//           </div>
//         </div>

//         {/* Actions */}
//         <div className="border-t border-gray-200 pt-8 space-y-4">
//           <div className="flex flex-col sm:flex-row gap-4">
//             <Link
//               to="/dashboard"
//               className="flex-1 btn btn-primary py-3"
//             >
//               View My Bookings
//             </Link>
//             <button
//               onClick={() => window.print()}
//               className="flex-1 btn btn-secondary py-3"
//             >
//               Print Confirmation
//             </button>
//           </div>
          
//           <Link
//             to="/"
//             className="block text-blue-600 hover:text-blue-500 text-sm"
//           >
//             Book Another Flight
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookingConfirmation;





// frontend/src/components/booking/BookingConfirmation.jsx - Compact & Beautiful Version
import React from 'react';
import { Link } from 'react-router-dom';

const BookingConfirmation = ({ booking }) => {
  const formatTime = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  // Handle missing booking data
  if (!booking) {
    return (
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-6 text-center">
          <div className="w-12 h-12 mx-auto bg-red-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-lg font-bold text-gray-900 mb-2">Booking Unavailable</h1>
          <p className="text-sm text-gray-600 mb-4">Unable to load booking details.</p>
          <Link to="/" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700">
            Return Home
          </Link>
        </div>
      </div>
    );
  }

  // Extract data with fallbacks
  const bookingReference = booking.booking_reference || booking.bookingReference || 'N/A';
  const totalAmount = booking.total_amount || booking.totalAmount || 0;
  const passengers = booking.passengers || [];
  const flight = booking.flight || {};
  const flightDetails = booking.flight_details || {};
  
  const flightInfo = {
    airline_name: flight.airline_name || flightDetails.airline_name || 'Unknown',
    flight_number: flight.flight_number || flightDetails.flight_number || 'N/A',
    origin_airport: flight.origin_airport || flightDetails.origin || 'N/A',
    destination_airport: flight.destination_airport || flightDetails.destination || 'N/A',
    origin_city: flight.origin_city || flight.origin_airport || 'N/A',
    destination_city: flight.destination_city || flight.destination_airport || 'N/A',
    departure_time: flight.departure_time || flightDetails.departure_time,
    arrival_time: flight.arrival_time || flightDetails.arrival_time
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        {/* Header Section */}
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-5 text-center text-white relative overflow-hidden">
          {/* Beautiful background pattern */}
          <div className="absolute inset-0 bg-white/5">
            <div className="absolute top-0 left-0 w-20 h-20 bg-white/10 rounded-full -translate-x-10 -translate-y-10"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 bg-white/10 rounded-full translate-x-8 translate-y-8"></div>
          </div>
          
          {/* Lovely checkmark with animation effect */}
          <div className="relative w-14 h-14 mx-auto mb-3">
            <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-lg transform animate-pulse">
              <div className="w-10 h-10 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            {/* Sparkle effects */}
            <div className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-300 rounded-full animate-ping"></div>
            <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-yellow-200 rounded-full animate-ping" style={{animationDelay: '0.5s'}}></div>
          </div>
          
          <h1 className="text-lg font-bold mb-1">Booking Confirmed!</h1>
          <p className="text-green-100 text-sm">Your flight is all set</p>
        </div>

        {/* Booking Reference */}
        <div className="px-4 py-3 bg-blue-50 border-b">
          <div className="text-center">
            <div className="text-xs text-blue-600 font-medium mb-1">BOOKING REFERENCE</div>
            <div className="text-base font-bold text-blue-800 tracking-wider">{bookingReference}</div>
          </div>
        </div>

        {/* Flight Info Card */}
        <div className="p-4">
          <div className="bg-gray-50 rounded-lg p-3 mb-3">
            <div className="flex justify-between items-center mb-2">
              <div className="text-sm font-semibold text-gray-900">
                {flightInfo.airline_name} {flightInfo.flight_number}
              </div>
              <div className="text-xs text-gray-500">
                {formatDate(flightInfo.departure_time)}
              </div>
            </div>
            
            {/* Route Visual */}
            <div className="flex items-center justify-between mb-2">
              <div className="text-center flex-1">
                <div className="text-base font-bold text-gray-900">{flightInfo.origin_airport}</div>
                <div className="text-xs text-gray-600">{formatTime(flightInfo.departure_time)}</div>
              </div>
              
              <div className="flex-1 flex items-center justify-center px-2">
                <div className="flex items-center">
                  <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                  <div className="flex-1 h-px bg-blue-600 mx-1"></div>
                  <svg className="w-3 h-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                  </svg>
                  <div className="flex-1 h-px bg-blue-600 mx-1"></div>
                  <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                </div>
              </div>
              
              <div className="text-center flex-1">
                <div className="text-base font-bold text-gray-900">{flightInfo.destination_airport}</div>
                <div className="text-xs text-gray-600">{formatTime(flightInfo.arrival_time)}</div>
              </div>
            </div>
          </div>

          {/* Passenger & Payment Summary */}
          <div className="space-y-2 mb-4">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Passengers</span>
              <span className="text-sm font-medium">{passengers.length}</span>
            </div>
            
            {passengers.slice(0, 2).map((passenger, index) => (
              <div key={index} className="flex justify-between items-center">
                <span className="text-sm text-gray-900 font-medium">
                  {passenger.first_name} {passenger.last_name}
                </span>
                <span className="text-xs text-gray-500">
                  {passenger.gender?.[0]?.toUpperCase()}
                </span>
              </div>
            ))}
            
            {passengers.length > 2 && (
              <div className="text-xs text-gray-500 text-center">
                +{passengers.length - 2} more passenger{passengers.length > 3 ? 's' : ''}
              </div>
            )}
            
            <div className="border-t pt-2 flex justify-between items-center">
              <span className="text-sm font-semibold text-gray-900">Total Paid</span>
              <span className="text-lg font-bold text-green-600">
                ${totalAmount ? totalAmount.toFixed(2) : '0.00'}
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-2">
            <div className="grid grid-cols-2 gap-2">
              <Link
                to="/dashboard"
                className="px-3 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 text-center transition-colors"
              >
                My Bookings
              </Link>
              <button
                onClick={() => window.print()}
                className="px-3 py-2 bg-gray-100 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors"
              >
                Print
              </button>
            </div>
            
            <Link
              to="/"
              className="block text-center text-blue-600 hover:text-blue-500 text-sm font-medium"
            >
              Book Another Flight
            </Link>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .max-w-md {
            max-width: none !important;
            margin: 0 !important;
          }
          .shadow-lg {
            box-shadow: none !important;
          }
          .bg-gradient-to-r {
            background: #10b981 !important;
            -webkit-print-color-adjust: exact;
          }
        }
      `}</style>
    </div>
  );
};

export default BookingConfirmation;